import { Injectable, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { environment } from '../../environments/environment';
import { WsService } from '../ws/ws.service';

@Injectable()
export class StatService implements OnInit, OnDestroy {

  private stats: any;
  private state: any;
  private lastStamp: any;

  private stateSubscription: Subscription;
  private userSubscription: Subscription;

  constructor(private ws: WsService) {
      this.stats = [];
      this.state = this.ws.getState();
      this.resetCounter();
      this.stateSubscription = this.ws.onState.subscribe(this.onChangeState.bind(this));
      this.userSubscription = this.ws.onUser.subscribe(this.onChangeUser.bind(this));
  }

  private onChangeState(state: any): void {
      if (!this.lastStamp) {
          this.resetCounter();
      }
      const nowStamp = Math.floor(new Date().valueOf() / 1000);
      const isoDate = new Date(1000 * (nowStamp + environment.SERVER_TZ_OFFSET)).toISOString().substring(0, 10);
      if (!this.stats[isoDate]) {
          this.stats[isoDate] = {
              start_at: isoDate.substring(8, 10) + '.' + isoDate.substring(5, 7) + '.' + isoDate.substring(0, 4),
              call_cnt: 0,
              all_time: 0,
              in_call: 0,
              in_pause: 0,
              in_save_result: 0
          }
      }
      let diff = nowStamp - this.lastStamp;
      if (this.state === this.ws.ST.UNAUTHORIZED) {
          diff = 0;
      }
      this.stats[isoDate].all_time += diff;
      if (this.state === this.ws.ST.CALL) {
          this.stats[isoDate].in_call += diff;
          if (this.state !== state) {
              this.stats[isoDate].call_cnt++;
          }
      }
      // время тестового звонка засчитывается как перерыв
      if ([this.ws.ST.PAUSED, this.ws.ST.ECHOTEST].indexOf(this.state) > -1) {
          this.stats[isoDate].in_pause += diff;
      }
      if (this.state === this.ws.ST.POSTPROCESS) {
          this.stats[isoDate].in_save_result += diff;
      }
      this.state = state;
      this.resetCounter();
  }

  private onChangeUser(user: any): void {
      if (user && user.stats) {
          this.initStats(user.stats);
      }
  }

  private resetCounter(): void {
      this.lastStamp = Math.floor(new Date().valueOf() / 1000);
  }

  public getStats(): any {
      let statDates = [];
      for (let d in this.stats) {
          if (this.stats.hasOwnProperty(d)) {
              statDates.push(d);
          }
      }
      statDates.sort();
      let sortedStats = [];
      for (let j=0; j<statDates.length; j++) {
          sortedStats.unshift(this.stats[statDates[j]]);
      }
      return sortedStats;
  }

  public initStats(data: any): any {
      this.stats = {};
      for (let j=0; j<data.length; j++) {
          const day = data[j];
          const isoDate = day.start_at.substring(6, 10) + '-' + day.start_at.substring(3, 5) + '-' + day.start_at.substring(0, 2);
          this.stats[isoDate] = day;
      }
  }

  ngOnInit() {
  }

  ngOnDestroy() {
      this.userSubscription.unsubscribe();
      this.stateSubscription.unsubscribe();
  }


}



// WEBPACK FOOTER //
// ./src/app/stat/stat.service.ts